/* IF Infinity Club v5: tappe fisse, le due strade del 3° mese si illuminano a turno */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function init(root) {
    if (!root || root.__ific) return;
    root.__ific = true;
    var branches = root.querySelectorAll('.ific__branch');
    var n = branches.length, cur = 0, timer = null, wait = null, paused = false, inView = false;
    var dur = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    root.style.setProperty('--ific-n', root.querySelectorAll('.ific__tick').length);

    function light(k) {
      each(branches, function (b, j) { b.classList.toggle('is-lit', j === k); b.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
      cur = k;
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } if (wait) { clearTimeout(wait); wait = null; } }
    function start() {
      if (reduce || paused || !inView || n < 2) return;
      stop();
      wait = setTimeout(function () {
        root.classList.add('is-cycling');
        light(cur);
        timer = setInterval(function () { light((cur + 1) % n); }, dur);
      }, 1600);
    }
    each(branches, function (b, idx) {
      b.addEventListener('click', function () { paused = true; stop(); root.classList.add('is-cycling'); light(idx); });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { inView = true; root.classList.add('is-visible'); start(); }
          else { inView = false; stop(); }
        });
      }, { threshold: 0.3 }).observe(root);
    } else { inView = true; root.classList.add('is-visible'); start(); }
  }

  function initAll() { each(document.querySelectorAll('.ific'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.ific'); if (r) init(r); });
})();